/**
 *
 * @param {string|*} what
 * @param {number} times
 * @returns {array|string}
 */
$.repeat = function repeat(what, times) {
    let result = [];

    for (let i = 0; i < times; i++) {
        result.push(what);
    }

    return ('string' === typeof what ? result.join('') : result);
};



// WEBPACK FOOTER //
// ./js/main/plugin/jquery.repeat.js